import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import jaTranslation from '../public/locales/ja/common.json';
import enTranslation from '../public/locales/en/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ja',
    debug: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    resources: {
      ja: {
        common: jaTranslation
      },
      en: {
        common: enTranslation
      }
    },
    ns: ['common'],
    defaultNS: 'common',
  });

export default i18n;
